import script from "./account.vue?vue&type=script&setup=true&lang=js"
export * from "./account.vue?vue&type=script&setup=true&lang=js"

import "./account.vue?vue&type=style&index=0&id=feb1fe26&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feb1fe26"]])

export default __exports__